import { Model } from "../libs/model/model";
import { PaymentMethodSingle } from "./paymentmethod-single";
import PaymentMethodApi from "../api/PaymentMethodApi";
import { runInAction } from "mobx";

export class PaymentMethodRepository extends Model {
  list: PaymentMethodSingle[] = PaymentMethodSingle.hasMany(this);


public async init() {
  runInAction(()=>{
    this.list = []
  })
}

  public async reload() {
    await PaymentMethodApi.getList().then((res: any) =>
    this._loadJSON({
      list: res,
    })
  );
  }
}

const PaymentMethodStore = PaymentMethodRepository.create({
  localStorage: false,
  storageName: "PaymentMethodRepository",
});
export default PaymentMethodStore;
